export const CdnBaseUrl = 'https://spceus1pd01cdnblobs01.blob.core.windows.net'
export const CdnClientUrl = `${CdnBaseUrl}/knowledgepoint/client`

const accountTypeAbbreviation = {
    AEFirm: 'AE',
    BuildingProductManufacturer: 'BPM',
    System: 'Deltek',
}

export const navigateToExternalLink = (
    link: string,
    selfWindow: boolean = false
) => {
    window.open(link, selfWindow ? '_self' : '_blank')
}

export const createProductionOnlineHelpUrl = (accountType: string): string => {
    const abbreviation = accountTypeAbbreviation[accountType]

    return !!abbreviation
        ? `https://help.deltek.com/product/Specpoint/1.0/${abbreviation}/index.html`
        : ''
}

export const createTestingOnlineHelpUrl = (accountType: string): string => {
    const abbreviation = accountTypeAbbreviation[accountType]

    return !!abbreviation
        ? `https://deoperations.deltek.com/product/Specpoint/1.0/${abbreviation}/index.html`
        : ''
}

/**
 * Validates a full URL path.  This validator will check if the URL contains HTTP/S at the beginning
 * and it will return false if it doesn't
 *
 * This only checks the format of the URL NOT if the domain actually exists.
 * @param url to validate
 */
export const validateFullUrlPath = (url: string) => {
    const urlValidatorExpression =
        /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gi
    const regex = new RegExp(urlValidatorExpression)

    return !!url.match(regex)
}

/**
 * Validates a full URL path.  This validator will test if url is valid based on regex
 * and it will return false if it doesn't
 * String should contain http|s://www.__.__
 * This will not check if url is valid domain
 * @param url string to validate
 */
export const validateStrictFullUrlPath = (url: string) => {
    const urlValidatorExpression =
        /^((http|https):\/\/)?www\.([A-z]+)\.([A-z]{2,})/
    const regex = new RegExp(urlValidatorExpression)
    return !!regex.test(url)
}
